let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3B2F1")).then(() => parcelRequire('dUwy1'));